import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renders GitHub-flavored markdown (the CRM report sections + Sally's research come
 * back as markdown). Links open in a new tab; styling stays minimal and inherits the
 * surrounding card typography.
 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="md-body" style={{ fontSize: 13, lineHeight: 1.55, color: "var(--text-1)" }}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node: _n, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
